import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ParentTag {
  _id: string;
  fieldName: string;
}

interface GetParentTagsParams {
  parentId: string;
}

export const getParentTagsAPI = async (params: GetParentTagsParams) => {
  const response = await baseAPI.get<Array<ParentTag>>(
    `/parents/${params.parentId}/tags`,
  );
  return response.data;
};

export const useGetParentTags = (params: GetParentTagsParams) => {
  return useQuery({
    queryKey: [KEYS.PARENT_TAGS, params.parentId],
    queryFn: () => getParentTagsAPI(params),
  });
};
